<div class="main-content profile-editor-page areas-editor-page">
  <div class="container-fluid">
    <section class="profile-editor-page__hero">
      <div class="profile-editor-page__copy">
        <h1>{{ tituloOperacion }} de Area</h1>
        <p>Configure tipo, estatus y puestos asociados sin salir del flujo de gestion.</p>
      </div>

      <div class="profile-editor-page__hero-actions">
        <button type="button" class="app-form-btn app-form-btn--secondary" (click)="back()">
          Regresar
        </button>
        <button type="button" class="app-form-btn app-form-btn--primary" (click)="guardarActualizar()">
          Guardar area
        </button>
      </div>
    </section>

    <div class="areas-editor-page__content">
      <div class="row profile-editor-page__layout areas-editor-page__layout">
        <div class="col-xl-4 col-lg-5">
          <section class="profile-editor-page__card areas-editor-page__card areas-editor-page__card--data">
            <div class="profile-editor-page__card-header">
              <div class="areas-editor-page__card-copy">
                <div class="profile-editor-page__card-title">
                  <i class="material-icons">domain</i>
                  <span>Datos del Area</span>
                </div>
                <span>Defina la identidad operativa y la forma en que el area participara en tickets.</span>
              </div>
            </div>

            <div class="profile-editor-page__card-body">
              <div class="row areas-editor-page__grid">
                <div class="col-12">
                  <mat-form-field appearance="outline" class="profile-editor-page__field">
                    <mat-label>Nombre de Area</mat-label>
                    <input matInput aria-label="Nombre de Area" type="text" [(ngModel)]="area.area" />
                  </mat-form-field>
                </div>

                <div class="col-sm-6">
                  <mat-form-field appearance="outline" class="profile-editor-page__field">
                    <mat-label>Estatus</mat-label>
                    <mat-select [(ngModel)]="area.estatus">
                      <mat-option value="ACTIVO">ACTIVO</mat-option>
                      <mat-option value="BAJA">BAJA</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <div class="col-sm-6">
                  <mat-form-field appearance="outline" class="profile-editor-page__field">
                    <mat-label>Tipo</mat-label>
                    <mat-select [(ngModel)]="area.tipo">
                      <mat-option value="RESOLUTORA">RESOLUTORA</mat-option>
                      <mat-option value="SOLICITANTE">SOLICITANTE</mat-option>
                      <mat-option value="AMBAS">AMBAS</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <div class="col-12">
                  <div class="areas-editor-page__toggle-card">
                    <div class="areas-editor-page__toggle-copy">
                      <strong>Area por default</strong>
                      <span>Marque esta opcion si el area sera la atencion principal de tickets.</span>
                    </div>

                    <mat-slide-toggle
                      #areaToggle
                      [(ngModel)]="area.defaultService"
                      (click)="confirmacionAreaDefault(areaToggle)"
                      (keydown.enter)="$event.target === $event.currentTarget ? confirmacionAreaDefault(areaToggle) : null">
                    </mat-slide-toggle>
                  </div>
                </div>
              </div>

              <div class="profile-editor-page__summary-list areas-editor-page__summary">
                <div class="profile-editor-page__summary-item">
                  <span>Area capturada</span>
                  <strong>{{ area?.area || "Pendiente de captura" }}</strong>
                </div>
                <div class="profile-editor-page__summary-item">
                  <span>Puestos registrados</span>
                  <strong>{{ totalRegistros || puestoList.length || 0 }}</strong>
                </div>
                <div class="profile-editor-page__summary-item">
                  <span>Atencion por default</span>
                  <strong>{{ area?.defaultService ? "Activa" : "No asignada" }}</strong>
                </div>
              </div>
            </div>
          </section>
        </div>

        <div class="col-xl-8 col-lg-7">
          <section class="profile-editor-page__card areas-editor-page__card areas-editor-page__card--puestos">
            <div class="profile-editor-page__card-header profile-editor-page__card-header--tree">
              <div class="areas-editor-page__card-copy">
                <div class="profile-editor-page__card-title">
                  <i class="material-icons">work_outline</i>
                  <span>Puestos Asociados</span>
                </div>
                <span>Agregue hasta cinco puestos relacionados con el area. Puede editar nombre y estatus antes de guardar.</span>
              </div>

              <div class="profile-editor-page__tree-meta">
                <span class="profile-editor-page__counter">
                  {{ totalRegistros || puestoList.length || 0 }} registros
                </span>
              </div>
            </div>

            <div class="profile-editor-page__card-body">
              <div class="areas-editor-page__toolbar">
                <mat-form-field appearance="outline" class="profile-editor-page__field areas-editor-page__field--wide">
                  <mat-label>Nombre del Puesto</mat-label>
                  <input matInput aria-label="Nombre del Puesto" type="text" [(ngModel)]="puest" />
                </mat-form-field>

                <button
                  type="button"
                  class="app-form-btn app-form-btn--primary app-form-btn--compact"
                  (click)="altaModificarPuesto()">
                  {{ bandEdit ? "Actualizar" : "Agregar" }}
                </button>
              </div>

              <div class="areas-editor-page__table-block" *ngIf="bandTabla; else areasPuestosState">
                <div class="table-page__table-wrap areas-editor-page__table-wrap">
                  <table class="table-page__table table-page__table--compact">
                    <thead>
                      <tr>
                        <th>Puesto</th>
                        <th>Estatus</th>
                        <th class="table-page__actions-head">Acciones</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let row of visiblePuestos; let i = index">
                        <td>
                          <strong class="table-page__name">{{ row.puesto }}</strong>
                        </td>
                        <td>
                          <div class="table-page__status-wrap">
                            <span class="table-page__status-badge" [ngClass]="row.estatus === 'ACTIVO' ? 'is-active' : 'is-inactive'">
                              {{ row.estatus }}
                            </span>
                            <mat-slide-toggle [checked]="row.estatus === 'ACTIVO'" (change)="onClicAcualizaStatus(row, $event)">
                            </mat-slide-toggle>
                          </div>
                        </td>
                        <td class="table-page__actions">
                          <button type="button" class="table-page__action-btn" (click)="modifica(row, i)">
                            <i class="material-icons">edit</i>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div class="table-page__footer areas-editor-page__footer" *ngIf="showPagination">
                  <div class="table-page__meta">
                    <span>Mostrando {{ rangeEnd }} de {{ totalRegistros }} puestos</span>

                    <label class="table-page__page-size">
                      <span>Ver:</span>
                      <select [ngModel]="pageSize" (ngModelChange)="onPageSizeChange($event)">
                        <option *ngFor="let option of pageSizeOptions" [ngValue]="option">{{ option }}</option>
                      </select>
                    </label>
                  </div>

                  <div class="table-page__pager" *ngIf="totalPages > 0">
                    <button type="button" class="table-page__pager-link" (click)="firstPage()" [disabled]="currentPage === 1">
                      Inicio
                    </button>
                    <button type="button" class="table-page__pager-link" (click)="previousPage()" [disabled]="currentPage === 1">
                      Anterior
                    </button>

                    <ng-container *ngFor="let item of getPaginationItems()">
                      <button
                        *ngIf="isPageNumber(item); else puestosPagerEllipsis"
                        type="button"
                        class="table-page__pager-page"
                        [class.is-current]="item === currentPage"
                        (click)="onPageChange(item)">
                        {{ item }}
                      </button>

                      <ng-template #puestosPagerEllipsis>
                        <span class="table-page__pager-ellipsis">...</span>
                      </ng-template>
                    </ng-container>

                    <button type="button" class="table-page__pager-link" (click)="nextPage()" [disabled]="currentPage === totalPages">
                      Siguiente
                    </button>
                    <button type="button" class="table-page__pager-link" (click)="lastPage()" [disabled]="currentPage === totalPages">
                      Ultimo
                    </button>
                  </div>
                </div>
              </div>

              <ng-template #areasPuestosState>
                <div class="table-page__empty areas-editor-page__empty-state" *ngIf="!loadingPuestos; else puestosLoadingState">
                  <i class="material-icons">work_outline</i>
                  <strong>Aun no hay puestos capturados</strong>
                  <span>Agregue al menos un puesto para completar la configuracion del area.</span>
                </div>
              </ng-template>

              <ng-template #puestosLoadingState>
                <div class="table-page__empty table-page__empty--loading areas-editor-page__empty-state">
                  <i class="material-icons">hourglass_top</i>
                  <strong>Cargando puestos...</strong>
                </div>
              </ng-template>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</div>
